import { Component, OnInit, Inject } from '@angular/core';
import { Globals } from '../../../../globals'
import { ISpedStudentDemographics } from '../../../../Models/ISpedStudentDemographics'
import { IIepInstance } from '../../../../Models/IIepInstance'
import { IepService } from "../../../../Services/IepService";
import { ILockStatus } from '../../../../Models/ILockStatus';
import { Message } from 'primeng/primeng';
import { Router } from "@angular/router";
import { ILookupBase } from '../../../../Models/ILookupBase';
import { ILookupSchoolYear } from '../../../../Models/ILookupSchoolYear';
import { LookupService } from 'src/app/Services/LookupService';
import { LookupTypeEnum } from 'src/app/Models/Enums/LookupTypeEnum';
import { FormIndividualizedTransitionPlanService } from '../../../../Services/FormIndividualizedTransitionPlanService';
import { IFormIndividualizedTransitionPlan } from "../../../../Models/Forms/IFormIndividualizedTransitionPlan";
import { IReportParameter } from 'src/app/Models/IReportParameter';
import { SpinnerBase } from '../../../Base/SpinnerBase';
import { ReportService } from 'src/app/Services/ReportService';


@Component({
  selector: 'IndividualizedTransitionPlan',
  templateUrl: './IndividualizedTransitionPlan.component.html',
  styleUrls: ['./IndividualizedTransitionPlan.component.css']
})
export class FormIndividualizedTransitionPlanComponent extends SpinnerBase {
  _myGlobals: Globals;
  _baseUrl: string;
  _iepService: IepService;
  successMessages: Message[];
  errorMessages: Message[];
  studentInfo: ISpedStudentDemographics;
  selectedIepInstance: IIepInstance;
  isLocked: boolean;
  lockStatus: string;
  canEditIep: boolean;
  saveClicked: boolean;
  formIndividualizedTransitionPlanDB: any = [];
  _lookupService: LookupService;
  _lookupCourseOfStudy: ILookupBase[];
  _schoolYearList: ILookupSchoolYear[];
  _lookupSchoolYear: ILookupBase[];
  _lookupSchoolYear1: ILookupBase[];
  _lookupSchoolYear2: ILookupBase[];
  _lookupSchoolYear3: ILookupBase[];
  _lookupSchoolYear4: ILookupBase[];
  selectedYear1Ids: any[];
  selectedYear2Ids: any[];
  selectedYear3Ids: any[];
  selectedYear4Ids: any[];
  chkNames: any = [];
  agency1: boolean;
  agency2: boolean;
  reportParamArray: IReportParameter[];
  fourYearsInFuture: Date;
  fiveYearsInPast: Date;
  fapeEndDate: Date;
  MeetingDatePlusYearMinusOneDay: Date;
  calendarYearRangeFourYears: string;
  calendarYearRangeFiveYearsBack: string;
  checkedTrue: boolean = true;
  checkedFalse: boolean = false

  constructor(
    private globals: Globals, reportservice: ReportService,
    private _formIndividualizedTransitionPlanService: FormIndividualizedTransitionPlanService,
    iepService: IepService,
    @Inject('BASE_URL') baseUrl: string,
    public router: Router,
    lookupService: LookupService) {
    super(reportservice);
    this._iepService = iepService;
    this._myGlobals = globals;
    this._baseUrl = baseUrl;
    this.studentInfo = this._myGlobals.spedStudentDemographics;
    this.selectedIepInstance = this._myGlobals.selectedIepInstance;
    this.chkNames = ['agency1', 'agency2'];
    this._lookupService = lookupService
  }

  ngOnInit(): void {
    this.LoadFormIndividualizedTransitionPlanDetails();
    this.isLocked = false;
    this.canEditIep = this._myGlobals.canEdit();
    this.successMessages = [];
    this.errorMessages = [];
    this.scrollToTop();
    let today = new Date();
    let mtgDate = this._myGlobals.selectedIepInstance.meetingDate;
    this.fourYearsInFuture = new Date(today.getFullYear() + 4, 5, 30);
    this.fiveYearsInPast = new Date(today.getFullYear() - 5, 6, 1);
    this.calendarYearRangeFourYears = today.getFullYear() + ':' + (today.getFullYear() + 4);
    this.calendarYearRangeFiveYearsBack = today.getFullYear() - 5 + ':' + today.getFullYear();
    this.MeetingDatePlusYearMinusOneDay = new Date(mtgDate.getFullYear() + 1, mtgDate.getMonth(), mtgDate.getDate() - 1);
    this.fapeEndDate = new Date(mtgDate.getFullYear() + 1, mtgDate.getMonth(), mtgDate.getDate() -1);
  }

  LoadFormIndividualizedTransitionPlanDetails(): void {
    this._formIndividualizedTransitionPlanService.getFormIndividualizedTransitionPlan(this._myGlobals.selectedFormDetails.formId)
      .subscribe((res: IFormIndividualizedTransitionPlan) => {
        this.formIndividualizedTransitionPlanDB = res,
          this.bindCheckboxOptions();
        this.setSelectedListboxValues();
        this.LoadLookupValues();

        if (this.formIndividualizedTransitionPlanDB.currentAge == null) {
          this.formIndividualizedTransitionPlanDB.currentAge = this.studentInfo.ageOnMeetingDate;
        }
        if (this.formIndividualizedTransitionPlanDB.planFilledDate == null) {
          this.formIndividualizedTransitionPlanDB.planFilledDate = new Date(this._myGlobals.selectedIepInstance.meetingDate);
        } 
        if (this.formIndividualizedTransitionPlanDB.agency1refdate != null) {
          this.formIndividualizedTransitionPlanDB.agency1refdate = new Date(this.formIndividualizedTransitionPlanDB.agency1refdate);
        }
        if (this.formIndividualizedTransitionPlanDB.agency2refdate != null) {
          this.formIndividualizedTransitionPlanDB.agency2refdate = new Date(this.formIndividualizedTransitionPlanDB.agency2refdate);
        }
        if (this.formIndividualizedTransitionPlanDB.cahseeElaDateTested != null) {
          this.formIndividualizedTransitionPlanDB.cahseeElaDateTested = new Date(this.formIndividualizedTransitionPlanDB.cahseeElaDateTested);
        }
        if (this.formIndividualizedTransitionPlanDB.eduDateDue != null) {
          this.formIndividualizedTransitionPlanDB.eduDateDue = new Date(this.formIndividualizedTransitionPlanDB.eduDateDue);
        }
        if (this.formIndividualizedTransitionPlanDB.empDateDue != null) {
          this.formIndividualizedTransitionPlanDB.empDateDue = new Date(this.formIndividualizedTransitionPlanDB.empDateDue);
        }
        if (this.formIndividualizedTransitionPlanDB.indeLivingDateDue != null) {
          this.formIndividualizedTransitionPlanDB.indeLivingDateDue = new Date(this.formIndividualizedTransitionPlanDB.indeLivingDateDue);
        }
        if (this.formIndividualizedTransitionPlanDB.mathDateTested != null) {
          this.formIndividualizedTransitionPlanDB.mathDateTested = new Date(this.formIndividualizedTransitionPlanDB.mathDateTested);
        }
        if (this.formIndividualizedTransitionPlanDB.planFilledDate != null) {
          this.formIndividualizedTransitionPlanDB.planFilledDate = new Date(this.formIndividualizedTransitionPlanDB.planFilledDate);
        }
        if (this.formIndividualizedTransitionPlanDB.projectedGraduation != null) {
          this.formIndividualizedTransitionPlanDB.projectedGraduation = new Date(this.formIndividualizedTransitionPlanDB.projectedGraduation);
        }
        if (this.formIndividualizedTransitionPlanDB.refCommCollegeDate != null) {
          this.formIndividualizedTransitionPlanDB.refCommCollegeDate = new Date(this.formIndividualizedTransitionPlanDB.refCommCollegeDate);
        }
        if (this.formIndividualizedTransitionPlanDB.refDeptRehaDate != null) {
          this.formIndividualizedTransitionPlanDB.refDeptRehaDate = new Date(this.formIndividualizedTransitionPlanDB.refDeptRehaDate);
        }
        if (this.formIndividualizedTransitionPlanDB.refMentalHealthDate != null) {
          this.formIndividualizedTransitionPlanDB.refMentalHealthDate = new Date(this.formIndividualizedTransitionPlanDB.refMentalHealthDate);
        }
        if (this.formIndividualizedTransitionPlanDB.refSocSecurityDate != null) {
          this.formIndividualizedTransitionPlanDB.refSocSecurityDate = new Date(this.formIndividualizedTransitionPlanDB.refSocSecurityDate);
        }
        if (this.formIndividualizedTransitionPlanDB.refSocServiceDate != null) {
          this.formIndividualizedTransitionPlanDB.refSocServiceDate = new Date(this.formIndividualizedTransitionPlanDB.refSocServiceDate);
        }
        if (this.formIndividualizedTransitionPlanDB.refTrainingDate != null) {
          this.formIndividualizedTransitionPlanDB.refTrainingDate = new Date(this.formIndividualizedTransitionPlanDB.refTrainingDate);
        }
        if (this.formIndividualizedTransitionPlanDB.refUniversityDate != null) {
          this.formIndividualizedTransitionPlanDB.refUniversityDate = new Date(this.formIndividualizedTransitionPlanDB.refUniversityDate);
        }
        if (this.formIndividualizedTransitionPlanDB.whenWereAgeOfMajorityRightsAdvised != null) {
          this.formIndividualizedTransitionPlanDB.whenWereAgeOfMajorityRightsAdvised = new Date(this.formIndividualizedTransitionPlanDB.whenWereAgeOfMajorityRightsAdvised);
        }
      },
        err => console.error(err)
      );

    if (this.selectedIepInstance.statusId == 1 && this._myGlobals.selectedStudent.exitDate == null)
    {
      this._formIndividualizedTransitionPlanService.getCreditsToDate(this._myGlobals.selectedIepInstance.id).subscribe((res: number) => {
        this.formIndividualizedTransitionPlanDB.creditToDate = res;
      },
        err => console.error(err)
      );
    }
  }

  setSelectedListboxValues() {
    if (this.formIndividualizedTransitionPlanDB.year1CourseOfStudyIds != null) {
      this.selectedYear1Ids = this.formIndividualizedTransitionPlanDB.year1CourseOfStudyIds.map(String);
    }
    if (this.formIndividualizedTransitionPlanDB.year2CourseOfStudyIds != null) {
      this.selectedYear2Ids = this.formIndividualizedTransitionPlanDB.year2CourseOfStudyIds.map(String);
    }
    if (this.formIndividualizedTransitionPlanDB.year3CourseOfStudyIds != null) {
      this.selectedYear3Ids = this.formIndividualizedTransitionPlanDB.year3CourseOfStudyIds.map(String);
    }
    if (this.formIndividualizedTransitionPlanDB.year4CourseOfStudyIds != null) {
      this.selectedYear4Ids = this.formIndividualizedTransitionPlanDB.year4CourseOfStudyIds.map(String);
    }
  }

  courseOfStudyChanged(id) {
    switch (id) {
      case 1:
        this.selectedYear1Ids = [];
        break;
      case 2:
        this.selectedYear2Ids = [];
        break;
      case 3:
        this.selectedYear3Ids = [];
        break;
      case 4:
        this.selectedYear4Ids = [];
        break;
    }
  }

  LoadLookupValues() {
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.CourseOfStudy]).subscribe((res: ILookupBase[]) => {
      this._lookupCourseOfStudy = res;
    },
      err => console.error(err)
    );
    this._lookupService.getRangeLookupSchoolYearList().subscribe((res: ILookupSchoolYear[]) => {
      this._schoolYearList = res;
      this._lookupSchoolYear = [] as ILookupBase[];
      this._lookupSchoolYear.push({ value: null, label: 'Select a School Year', shortText: null, updatedOn: null });

      let templookupSchoolYear = this._schoolYearList.map(o => {
        return {
          value: o.schoolYear,
          label: o.schoolYear,
          shortText: null,
          updatedOn: null
        };
      });

      this._lookupSchoolYear.push.apply(this._lookupSchoolYear, templookupSchoolYear);
      this.LoadYearDDLValues();
    },
      err => console.error(err)
    );
  }

  LoadYearDDLValues() {
    if (this._lookupSchoolYear.filter(e => e.value === this.formIndividualizedTransitionPlanDB.year1).length > 0) {
      this._lookupSchoolYear1 = this._lookupSchoolYear;
    }
    else {
      this._lookupSchoolYear1 = [{ value: this.formIndividualizedTransitionPlanDB.year1, label: this.formIndividualizedTransitionPlanDB.year1, shortText: null, updatedOn: null }].concat(this._lookupSchoolYear);
    }

    if (this._lookupSchoolYear.filter(e => e.value === this.formIndividualizedTransitionPlanDB.year2).length > 0) {
      this._lookupSchoolYear2 = this._lookupSchoolYear;
    }
    else {
      this._lookupSchoolYear2 = [{ value: this.formIndividualizedTransitionPlanDB.year2, label: this.formIndividualizedTransitionPlanDB.year2, shortText: null, updatedOn: null }].concat(this._lookupSchoolYear);
    }

    if (this._lookupSchoolYear.filter(e => e.value === this.formIndividualizedTransitionPlanDB.year3).length > 0) {
      this._lookupSchoolYear3 = this._lookupSchoolYear;
    }
    else {
      this._lookupSchoolYear3 = [{ value: this.formIndividualizedTransitionPlanDB.year3, label: this.formIndividualizedTransitionPlanDB.year3, shortText: null, updatedOn: null }].concat(this._lookupSchoolYear);
    }

    if (this._lookupSchoolYear.filter(e => e.value === this.formIndividualizedTransitionPlanDB.year4).length > 0) {
      this._lookupSchoolYear4 = this._lookupSchoolYear;
    }
    else {
      this._lookupSchoolYear4 = [{ value: this.formIndividualizedTransitionPlanDB.year4, label: this.formIndividualizedTransitionPlanDB.year4, shortText: null, updatedOn: null }].concat(this._lookupSchoolYear);
    }
  }

  bindCheckboxOptions() {
    for (var item of this.chkNames) {
      if (this.formIndividualizedTransitionPlanDB[item] == 'Y') {
        this[item] = true
      }
      else {
        this[item] = false
      }
    }
  }

  updateCheckboxOptions() {
    for (var item of this.chkNames) {
      if (this[item] == true) {
        this.formIndividualizedTransitionPlanDB[item] = 'Y'
      }
      else {
        this.formIndividualizedTransitionPlanDB[item] = 'N'
      }
    }

  }

  clearMessages() {
    this.successMessages = [];
    this.errorMessages = [];
  }

  addMessage(msg: Message) {
    if (msg.severity == 'error') {
      this.errorMessages = [...this.errorMessages, msg];
    }
    else {
      this.successMessages = [...this.successMessages, msg];
    }
  }

  LivingArrangementsClick(LivingArrangementsOption) {
    if (LivingArrangementsOption == 'WithFamily') {
      this.formIndividualizedTransitionPlanDB.livingIndependent = false
      this.formIndividualizedTransitionPlanDB.livingOther = false
    }
    else if (LivingArrangementsOption == 'Independent') {
      this.formIndividualizedTransitionPlanDB.livingFamilyRelation = false
      this.formIndividualizedTransitionPlanDB.livingOther = false
    }
    else if (LivingArrangementsOption == 'Other') {
      this.formIndividualizedTransitionPlanDB.livingFamilyRelation = false
      this.formIndividualizedTransitionPlanDB.livingIndependent = false
    }
  }

  LeisureRecreationClick(LeisureRecreationOption) {
    if (LeisureRecreationOption == 'Organization') {
      this.formIndividualizedTransitionPlanDB.leiRecFamilyFriend = false
      this.formIndividualizedTransitionPlanDB.leiRecOther = false
    }
    else if (LeisureRecreationOption == 'FamilyFriend') {
      this.formIndividualizedTransitionPlanDB.leiRecOrganization = false
      this.formIndividualizedTransitionPlanDB.leiRecOther = false
    }
    else if (LeisureRecreationOption == 'Other') {
      this.formIndividualizedTransitionPlanDB.leiRecOrganization = false
      this.formIndividualizedTransitionPlanDB.leiRecFamilyFriend = false
    }
  }

  loadUnLock(action) {
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=' + action)
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
      },
        err => console.error(err)
      );
  }

  edit() {
    this.clearMessages();
    this.saveClicked = false;
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=Lock')
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
        if (this.isLocked == true) {
          this.globals.editMode = true;
        }
        else {
          let failedMessage: Message = { severity: 'warn', summary: this.lockStatus }
          this.addMessage(failedMessage);
        }
      });
  }

  SaveSelectedListboxValues() {
    this.formIndividualizedTransitionPlanDB.year1CourseOfStudyIds = this.selectedYear1Ids;
    this.formIndividualizedTransitionPlanDB.year2CourseOfStudyIds = this.selectedYear2Ids;
    this.formIndividualizedTransitionPlanDB.year3CourseOfStudyIds = this.selectedYear3Ids;
    this.formIndividualizedTransitionPlanDB.year4CourseOfStudyIds = this.selectedYear4Ids;
  }

  //Save the IndividualizedTransitionPlan
  save(action) {
    this.scrollToTop();
    this.clearMessages();
    this.saveClicked = true;
    this.updateCheckboxOptions();
    this.SaveSelectedListboxValues()

    //update values
    this._formIndividualizedTransitionPlanService.insertUpdateFormIndividualizedTransitionPlan(this.formIndividualizedTransitionPlanDB)
      .subscribe((res: IFormIndividualizedTransitionPlan) => {
        let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: res.id.toString() }
        this.addMessage(successMessage);
        if (action == 'Close') {
          this.globals.editMode = false;
          this.loadUnLock("UnLock");
        }
        this.saveClicked = false;
        this.validateForm();
        this.LoadFormIndividualizedTransitionPlanDetails();
      },
        (error) => {
          let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
          this.addMessage(errorMessage);
          this.saveClicked = false;
        }
      )
  }

  validateForm() {
    this._formIndividualizedTransitionPlanService.validateForm(this._myGlobals.selectedFormDetails.formId)
      .subscribe((res: string[]) => {
        for (var item of res) {
          let errorMessage: Message = { severity: 'error', summary: 'Validation Error', detail: item };
          this.addMessage(errorMessage);
        }
      },
        err => console.error(err)
      );
  }

  cancel() {
    this.clearMessages();
    this.globals.editMode = false;
    this.loadUnLock("UnLock");
    this.LoadFormIndividualizedTransitionPlanDetails();
  }

  populateReportParameters() {
    this.reportParamArray = [];
    this.reportParamArray.push(
      { parameterName: 'RequestID', parameterValue: '0' },
      { parameterName: 'isDraft', parameterValue: this._myGlobals.selectedDashboardDocument.status == 'Draft' ? 'True' : 'False' },
      { parameterName: 'FormInstanceID', parameterValue: this.formIndividualizedTransitionPlanDB.iepFormInstanceId.toString() },
      { parameterName: 'ShowCustomWaterMark', parameterValue: this._myGlobals.selectedDashboardDocument.status == 'Draft' ? 'true' : 'false' },
      { parameterName: 'CustomWatermarkText', parameterValue: 'DRAFT DRAFT DRAFT' },
      { parameterName: 'BlankForm', parameterValue: 'false' },
    );
  }

  printEnglish() {
    this.populateReportParameters();
    this.printFormCommon(this.formIndividualizedTransitionPlanDB.rdlFileNameEnglish, this.reportParamArray);
  }

  printSpanish() {
    this.populateReportParameters();
    this.printFormCommon(this.formIndividualizedTransitionPlanDB.rdlFileNameSpanish, this.reportParamArray);
  }

}

